import {CERT_SET_CERTIFICATE ,SET_CONTRIBUTOR_CERTIFICATE} from '../constants'

const initialState = {
    Certificates:[],
    Contributor:[]
  };

  export const certificatesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case CERT_SET_CERTIFICATE: {
            return {
              ...state,
              Certificates: payload,
            };
          }
          case SET_CONTRIBUTOR_CERTIFICATE:{
            return {
              ...state,
              Contributor: payload,
            };
          }
      default: {
        return state;
      }
    }
  };
  